/**
 * @file: context.ts
 * @copyright: (c) 2019-2021 sichuan zhichetech co., ltd.
 */

import { createContext, useContext } from 'react';
import { FieldErrorAnchorKey } from './anchorKeys';
import { WindowRect } from './measureInWindowAsync';

export type FieldErrorAnchor = {
  measure: () => Promise<WindowRect | undefined>;
  shake: () => void;
};

export type FieldErrorFocusContextProps = {
  /** returns the unregister function */
  registerAnchor: (
    key: FieldErrorAnchorKey,
    anchor: FieldErrorAnchor,
  ) => () => void;
  /**
   * brings the topmost of the given rows into view and shakes it.
   * resolves with `false` when none of them is currently rendered.
   */
  focusFirstError: (keys: FieldErrorAnchorKey[]) => Promise<boolean>;
};

export const FieldErrorFocusContext =
  createContext<FieldErrorFocusContextProps | null>(null);

export const useFieldErrorFocus = () => useContext(FieldErrorFocusContext);
